var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDesktopAccessDisabled = function SvgDesktopAccessDisabled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_59_10189",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(-1 0 0 1 24 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_59_10189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3 13H17.2C17.0895 13 17 13.0895 17 13.2V20.8C17 20.9105 17.0895 21 17.2 21H21.3C21.4105 21 21.5 20.9105 21.5 20.8V13.2C21.5 13.0895 21.4105 13 21.3 13Z",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7345 3.50775L19.4383 4.99625C19.5153 4.99625 19.3743 4.93208 19.4383 4.99625C19.5024 5.06025 19.5345 5.13075 19.5345 5.20775L19.5001 11.5C19.5001 11.5 15.2509 15.9 15.2509 17.4C15.2509 15.5857 15.2509 15.9 15.2509 15.9H9.44977L22.296 3.05375L21.2423 2L2.00002 21.2423L3.05377 22.296L7.94977 17.4H10.0345V19.4H8.03452V20.9H15.0345V19.4H13.0345V17.4H13.5H15.2509C15.5001 16 18.0001 13.5 18.0001 13.5L19.5001 11.5C20.0053 11.5 20.5001 11.5 21.0001 11.5C21.0001 11 21.0001 11.5052 21.0001 11L21.0345 5.20775C21.0345 4.66158 20.8595 4.24167 20.5095 3.948C20.1595 3.6545 20.5095 3.948 19.7345 3.50775ZM3.15177 17.25L4.50177 15.9H3.79427C3.7301 15.8872 3.67077 15.8551 3.61627 15.8038C3.56177 15.7526 3.53452 15.6821 3.53452 15.5922V5.20775C3.53452 5.11792 3.56335 5.04417 3.62102 4.9865C3.67869 4.92883 3.75244 4.9 3.84227 4.9H15.5018L17.0018 3.4H3.84227C3.3371 3.4 2.90952 3.575 2.55952 3.925C2.20952 4.275 2.03452 4.70258 2.03452 5.20775V15.5922C2.03452 15.9742 2.13777 16.3143 2.34427 16.6125C2.5506 16.9105 2.81977 17.123 3.15177 17.25Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDesktopAccessDisabled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "desktop-access-disabled.f0c3bfb70da56924e62f2b0e892590bc.svg";